import type { ReactNode } from 'react'
import MarketingLayout from '@/layouts/MarketingLayout'

const pages = import.meta.glob<{ default: { layout?: (page: ReactNode) => ReactNode } }>(
  // Exclude co-located test files (a globbed *.test.tsx pulls vitest into the
  // production bundle and crashes the app at runtime).
  ['../pages/marketing/**/*.tsx', '!../pages/marketing/**/*.test.tsx'],
  { eager: true }
)

export function resolveMarketingPage(name: string) {
  const page = pages[`../pages/marketing/${name}.tsx`]
  if (!page) throw new Error(`Marketing page not found: ${name}`)

  page.default.layout ??= (pageNode: ReactNode) => <MarketingLayout>{pageNode}</MarketingLayout>
  return page
}
